<template>
  <v-dialog v-model="dialog"
            max-width="420">
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <v-card>
      <v-card-title class="text-h5">
        {{ $t(headerProp) }}
      </v-card-title>
      <v-card-text>
        <div>{{ textProp !== undefined ? $t(textProp) : text }}</div>
        <slot name="content" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text
               @click="
            dialog = false;
            $emit('close');
          ">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn v-if="to"
               color="red"
               text
               :to="to">
          {{ $t('label.yes') }}
        </v-btn>
        <v-btn v-else
               color="red"
               text
               @click="
            dialog = false;
            $emit('click');
          ">
          {{ $t('label.yes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from '@/mixins/common';

export default {
  mixins: [common],
  props: {
    headerProp: { type: String, required: true },
    textProp: String,
    text: String,
    to: { type: String, required: false },
    open: { type: Boolean, default: undefined },
  },
  data() {
    return { dialog: this.open || false };
  },
  watch: {
    open(v) {
      this.dialog = v;
    },
  },
};
</script>
